export default __webpack_public_path__ + "static/media/no_drinking.ec928bf4.svg";